<template>
    <div
        :data-component="$options.name"
        class="flex flex-wrap w-full"
    >
        <cs-checkbox
            v-for="filter in filterValues"
            :key="filter.key"
            class="w-full screen-m:w-1/2"
            :modelValue="selectedCategories"
            :value="filter.value"
            :name="filter.label"
            @update:modelValue="onUpdateCategory"
            >{{ filter.label }}</cs-checkbox
        >
    </div>
</template>
<script lang="ts" src="./CsNewsCategory.ts" />
